import React, { Component } from 'react';
import { Form, Input, Button, Table, message } from 'antd';
import { base } from '../../base';

class OrderAddContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            products: [],
            total: 0,
            weight: 0,
            loading: false,
            saving: false,
            key: null
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    handleSave() {
        this.setState({ saving: true });
        const self = this;
        if(this.state.key === null) {
            var refData = base.push('orders', {
                data: { 
                    client: this.props.user.email,
                    date: (new Date()).getTime(),
                    total: this.state.total,
                    weight: this.state.weight,
                    products: this.state.products,
                },
                then(err){
                  if(!err){
                    self.setState({ saving: false });
                    message.success("Se guardo la orden correctamente")
                  } else {
                    self.setState({ saving: false, key: null });
                    message.error("Ocurrio un error al guardar la orden")
                  }
                }
            });
            this.setState({ key: refData.key });
        } else {
            base.update(`orders/${this.state.key}`, {
                data: { 
                    total: this.state.total,
                    weight: this.state.weight,
                    products: this.state.products,
                },
                then(err){
                  if(!err){
                    self.setState({ saving: false });
                    message.success("Se actualizo la orden correctamente")
                  } else {
                    self.setState({ saving: false, key: null });
                    message.error("Ocurrio un error al actualizar la orden")
                  }
                }
            });
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({
                    loading: true,
                });
                base.fetch('products', {
                    context: this,
                    asArray: true,
                    queries: {
                        orderByChild: 'part_num',
                        equalTo: values.part_num,
                    },
                    then(data){
                        this.setState({
                            loading: false,
                        });
                        if(data.length > 0) {
                            const { products, total, weight } = this.state;

                            const row = data[0];
                            row.cant = values.cant;
                            this.props.form.resetFields();
                            this.setState({
                                products: products.concat(row),
                                total: total + row.cant * row.price,
                                weight: weight + row.cant * row.kg_per_pc,
                            });
                        } else {
                            message.error("No se encontro el numero de parte");
                        }
                        
                    }
                });
            }
        });
      }

    renderForm() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Form layout='inline' onSubmit={this.handleSubmit}>
                <Form.Item>
                    {getFieldDecorator('cant', {
                        rules: [{ required: true, message: 'Ingrese una cantidad' }],
                    })(
                        <Input placeholder="Cant" style={{ width: '70px'}} />
                    )}
                </Form.Item>
                <Form.Item>
                    {getFieldDecorator('part_num', {
                        rules: [{ required: true, message: 'Ingrese un número de parte' }],
                    })(
                        <Input placeholder="Número de parte" />
                    )}
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={this.state.loading}>{!this.state.loading && 'Agregar'}</Button>
                </Form.Item>
            </Form>
        );
    }

    render() {          
        const columns = [{
            title: 'Cant',
            dataIndex: 'cant',
            key: 'cant',
        }, {
            title: 'Número de Parte',
            dataIndex: 'part_num',
            key: 'part_num',
        }, {
            title: 'Precio',
            dataIndex: 'price',
            key: 'price',
            render: (txt, row) => '€ ' + (row.cant * txt)
        }];

        return (
            <div>
                <Button type="primary" icon="poweroff" loading={this.state.saving} onClick={this.handleSave}>
                    Guardar Orden
                </Button>
                <b style={{ fontSize: 16 }}>  Total: € {this.state.total}</b>
                <hr/>
                {this.renderForm()}
                <Table 
                    dataSource={this.state.products}
                    columns={columns}
                    expandedRowRender={record => (
                        <p style={{ margin: 0 }}>
                            {record.description_en}
                        </p>
                    )}
                />
            </div>
            
        );
    }
}

export default Form.create()(OrderAddContainer);



// WEBPACK FOOTER //
// ./src/components/containers/OrderAddContainer.jsx